export default __webpack_public_path__ + "static/media/servo_270.0adfa7b4.png";